<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Obras</h3>
        <router-link class="btn btn-success text-white float-right " :to="{ name: 'admin-project-new'}" v-if="!isCustomer">Novo obra</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Obras Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <project-table :projects="projects.list" />
            </div>
            <pagination :total-items="projects.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import ProjectTable from '../components/ProjectListTable.vue';

export default {
  name: 'project-list',
  components: {
    Pagination,
    ProjectTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    projects() {
      const { projectList } = this.$store.state.project;
      if (projectList && projectList.list.length) {
        return projectList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getProjectList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getProjectList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
